import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '@outlaw/core';
import { CommunityConfigService } from '../util';

@Injectable({ providedIn: 'root' })
export class CommunityAuthService {
  #internalApi = inject(CommunityConfigService).internalApi;
  #http = inject(HttpClient);

  getUserData<T = User>(): Observable<T> {
    return this.#http.get<T>(this.#internalApi.userUrl + '/');
  }
}
